import lodashIsEmpty from 'lodash/isEmpty';

import { ModalManager } from '../../../Components/Web/Modal/hooks/useModalManager';
import { MODALPROMPT } from '../../../Components/Web/Modal/ModalPrompt/config';
import { OrderDates } from '../../../RTK/api/store/types';
import { checkout } from '../../../RTK/defaultValues';

import useCheckoutHandler from '../controller/useCheckoutHandler';

const useDeliveryEstimate = (orderDates: OrderDates) => {
  const {
    checkoutInfo,
    formDeliverySchedule,
    isPickup,
    onUpdateCheckoutDetails,
  } = useCheckoutHandler();

  const _onDeliveryScheduleChanged = (value) => {
    onUpdateCheckoutDetails(checkout.keys.DELIVERY_SCHEDULE, value);
  };

  const _showScheduleListModal = async (error) => {
    if (checkoutInfo.days_accepting_in_advance) {
      const result = await ModalManager.show(
        MODALPROMPT.changeDateAndTimeSchedule,
        {
          payload: {
            value: formDeliverySchedule,
            modalTitle: 'Later (Schedule Order Later)',
            error,
          },
        },
      );
      if (!lodashIsEmpty(result?.label)) {
        onUpdateCheckoutDetails(checkout.keys.DELIVERY_SCHEDULE, result);
      }
    } else {
      // open modal for changing time for today
      const result = await ModalManager.show(MODALPROMPT.changeTimeSchedule, {
        payload: {
          title: `Select ${isPickup ? 'Pickup' : 'Dispatch'} Time`,
          modalTitle: 'Later (Schedule Order Later)',
          value: formDeliverySchedule,
          orderTimeSlot: orderDates,
          error,
        },
      });
      if (!lodashIsEmpty(result?.label)) {
        onUpdateCheckoutDetails(checkout.keys.DELIVERY_SCHEDULE, result);
      }
    }
  };

  return {
    value: formDeliverySchedule,
    onDeliveryScheduleChanged: _onDeliveryScheduleChanged,
    showScheduleListModal: _showScheduleListModal,
  };
};

export default useDeliveryEstimate;
